import DefinitionConditionListP from './recordm.presenter.definition.conditionlist.js';
import DefinitionFieldV from '../view/recordm.view.definition.field.js';

import utils from '@cob/ui-genesis/cob.utils.js';

var DefinitionFieldP = function(core, parent, field, nanny, readonly) {
    var _condListP;
    var _canHaveChildren = field.fields && field.fields.length > 0;
    var _nanny = nanny;

    var _fieldBuilder = new DefinitionFieldP.NewFieldBuilder(core, {expand: () => {
        parent.expand();
    }});

    var view = new DefinitionFieldV(core, {

        toggle_group: function(){
            _canHaveChildren = !_canHaveChildren;
            if (_canHaveChildren) {
                view.expandFields();
            } else {
                view.colapseFields();
            }

        },

        toggle_children: function(){
            if (_canHaveChildren) {
                if (view.isChildBlockVisible()) {
                    view.colapseFields();
                } else {
                    view.expandFields();
                }
            }
        },

        // event is filled when called by jquery handlers
        // name is passed by the "special" multifield paste listener
        bottom_field_add: function(event, name){
            var newField = _fieldBuilder.buildFor(_nanny, name ? {name: name} : {});

            core.translate('recordm.definition', newField.content());

            view.addBottomField(newField);
            _nanny.addChildAfter(field.id, newField);
        },

        bottom_field_drop: function($dropedElement){
            var oldNanny = $dropedElement.data('nanny');

            //remove the Presenter from the oldNanny
            var hisPresenter = oldNanny.removeChild($dropedElement.data('fieldId'));

            //set the new nanny, both in the Presenter and the data attribute
            hisPresenter.setNanny(_nanny);
            $dropedElement.data('nanny', _nanny);

            //add to our fields
            view.addBottomField(hisPresenter);
            _nanny.addChildAfter(field.id, hisPresenter);
        },

        remove: function(){
            _nanny.removeChild(field.id);
            view.destroy();
        }

    });

    //someday jone isto provavelmente devia ser feito no model...
    var _prepareFieldForView = function(){
        field.editable = !readonly;
        field.hasChildren = field.fields && field.fields.length > 0;

        //todo jone ver se isto não está a ser feito duas vezes.
        //hack para contornar erro do jQuery.tmpl (bug https://www.pivotaltracker.com/story/show/9902075)
        field.description = field.description || '';
    };

    var _getFieldDef = function() {
        var selfModel = view.getModel();

        if (_canHaveChildren) {
            selfModel.fields = _condListP.getFieldDefs();
        }

        if (selfModel.fields === null) delete selfModel.fields;

        return selfModel;
    };

    var _init = function() {
        core.subscribe('expand-fields', function() {
            if (_canHaveChildren) view.expandFields();
        });
        core.subscribe('collapse-fields', function() {
            view.colapseFields();
        });

        _prepareFieldForView();
        view.showField(field, _nanny);

        _condListP = new DefinitionConditionListP(core, {expand: () => {
            view.expandFields();
            parent.expand();
        }}, view.getConditionListContainer(), field, readonly);
    };
    _init();

    return {
        showErrors: function(errors) {
            view.clearErrors();
            if(errors[field.id]){
                const nonViz = errors[field.id].filter((e) => !e.type.startsWith('Visibility_'));
                if(nonViz.length > 0){
                    view.showErrors(nonViz);
                    parent.expand();
                    view.focusNameField();
                }
            }

            _condListP.showErrors(errors);
        },

        getId: function() {
            return field.id;
        },
        content: function() {
            return view.getContainer();
        },
        focus: function() {
            view.focusNameField();
        },

        getFieldDef: _getFieldDef,

        // Changes a FieldP's nanny. It's only used when dragging and dropping a field between different nannies.
        setNanny: function(nanny) {
            _nanny = nanny;
        }
    }
};

DefinitionFieldP.NewFieldBuilder = function(core, parent) {
    this.buildFor = function(nanny, partialFieldDef, readOnly) {
        var newId = core.locallyUniqueId();

        var _fieldDef = partialFieldDef || {};
        utils.extend(_fieldDef, {id: newId, name: '', description: '', duplicable: false});

        //Hack: Avoid tmpl bug on [HTML Object Element] on description input fields
        return  new DefinitionFieldP(
            core,
            parent,
            _fieldDef,
            nanny,
           readOnly
        );
    };
};


export default DefinitionFieldP;
